import { useNavigate, useLocation } from "react-router-dom";

import "./sidebar.css";

import {
  AllCoursesIcon,
  AllCoursesIconActive,
  OngoingIcon,
  OngoingIconActive,
} from "./Icons";

function EmployeeDashboardItem(props) {
  const { Icon, path, text, active } = props;
  const navigate = useNavigate();
  function onClick() {
    navigate(path);
  }

  function getClassName() {
    if (active)
      return "DashboardSidebarItem DashboardSidebarItemActive"
    return "DashboardSidebarItem";
  }

  return (
    <div className={getClassName()} onClick={onClick}>
      <div className="DashboardSidebarItemIcon">
        <Icon />
      </div>
      <div className="DashboardSidebarItemText">
        {text}
      </div>
    </div>
  )
}

function EmployeeDashboardItems() {
  const { pathname } = useLocation();
  const items = [
    {
      Icon: "/employee/dashboard" === pathname ? AllCoursesIconActive : AllCoursesIcon,
      path: "/employee/dashboard",
      text: "All Courses",
      active: "/employee/dashboard" === pathname,
    },
    {
      Icon: "/employee/dashboard/ongoing" === pathname ? OngoingIconActive : OngoingIcon,
      path: "/employee/dashboard/ongoing",
      text: "My Courses",
      active: "/employee/dashboard/ongoing" === pathname,
    }
  ]
  return (
    <div className="DashboardSidebarItems">
      {items.map((_props) => <EmployeeDashboardItem {..._props} />)}
    </div>
  )
}

function EmployeeSidebar() {
  return (
    <div className="DashboardSidebar">
      <div className="DashboardSidebarLogoContainer">
        <div className="DashboardSidebarLogo" />
      </div>
      <EmployeeDashboardItems />
    </div>
  )
}

export default EmployeeSidebar;
